import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faFacebook} from '@fortawesome/free-brands-svg-icons'
const FacebookIcon = () => {
  return (
    <FontAwesomeIcon icon={faFacebook}/>
  )
}

export default FacebookIcon